module.exports = __webpack_public_path__ + "static/media/SFC Application Btn.c47dc822.png";